// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__201xL","title":"styles_title__3yMAq"};